import { Box, Stack, Typography } from '@mui/material';
import { Card, CardMedia, CardContent } from '../common/Card/index.js';
import { PLACEHOLDER_IMAGES } from '../../constants/images';
import { EXTERNAL_LINKS } from '../../constants/links';

const HeroSection = ({ onVideoOpen, onSlidesOpen }) => {
  const cardHeight = 400;
  
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 4, alignItems: 'stretch' }}>
      <Box sx={{ width: { xs: '100%', md: '66.66%' }, display: 'flex' }}>
        <Card
          height={cardHeight}
          onClick={onSlidesOpen}
          sx={{ width: '100%', height: `${cardHeight}px` }}
        >
          <CardMedia 
            image={PLACEHOLDER_IMAGES.hero.gameplay} 
            alt="Gameplay"
          />
          <CardContent 
            title="GAMEPLAY"
            subtitle="Find out more about the unique multiplayer life simulation game everyone's talking about!"
            titleImage={PLACEHOLDER_IMAGES.hero.gameplayTitle}
            isSpecialTitle
          />
        </Card>
      </Box>
      <Box sx={{ width: { xs: '100%', md: '33.33%' }, display: 'flex' }}>
        <Card
          height={cardHeight}
          href={EXTERNAL_LINKS.paradiseChain}
          sx={{ width: '100%', height: `${cardHeight}px` }}
        >
          <CardMedia 
            image={PLACEHOLDER_IMAGES.hero.comingSoon} 
            alt="Paradise Chain L1"
          />
          <Box sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%',
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)',
            boxSizing: 'border-box',
            overflow: 'hidden'
          }}>
            {/* Logo taking most of the space */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              width: '100%',
              paddingTop: '40px'
            }}>
              <Box
                component="img"
                src="/img/features/paradise-chain-logo.png"
                alt="Paradise Chain L1"
                sx={{
                  maxHeight: '200px',
                  maxWidth: '90%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </Box>
            {/* Text at the bottom */}
            <Box sx={{
              padding: '16px',
              alignSelf: 'flex-start',
              width: '100%'
            }}>
              <Typography variant="subtitle1" sx={{
                fontFamily: '"Luckiest Guy", cursive',
                color: '#F7F3E9',
                fontSize: '1.26rem',
                letterSpacing: '0.05em',
                lineHeight: '1.2',
              }}>
                Read more about Paradise Chain L1
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    </Stack>
  );
};

export default HeroSection; 